import api from './api.js'

export const getUsers = (page = 0, size = 20, search = '') => {
  const params = { page, size }
  if (search) params.search = search
  return api.get('/admin/v1/users', { params })
}

export const getUserById = (id) => api.get(`/admin/v1/users/${id}`)

export const updateUser = (id, data) => api.patch(`/admin/v1/users/${id}`, data)

export const getUserStats = () => api.get('/admin/v1/users/stats')

export const getUserVehicles = (userId, page = 0, size = 20) =>
  api.get(`/admin/v1/users/${userId}/vehicles`, { params: { page, size } })

export const getUserActivityTimeline = (userId, limit = 50) =>
  api.get(`/admin/v1/users/${userId}/activity/timeline`, { params: { limit } })

export const getUserActivitySummary = (userId) =>
  api.get(`/admin/v1/users/${userId}/activity/summary`)

export const getUserFuelEntries = (userId, page = 0, size = 20) =>
  api.get(`/admin/v1/users/${userId}/activity/fuel`, { params: { page, size } })

export const getUserRepairEntries = (userId, page = 0, size = 20) =>
  api.get(`/admin/v1/users/${userId}/activity/repairs`, { params: { page, size } })

export const getUserInsurancePolicies = (userId, page = 0, size = 20) =>
  api.get(`/admin/v1/users/${userId}/activity/insurance`, { params: { page, size } })

export const getUserSubscription = (userId) =>
  api.get(`/admin/v1/users/${userId}/subscription`)

export const getUserPayments = (userId) =>
  api.get(`/admin/v1/users/${userId}/subscription/payments`)

export const grantUserSubscription = (userId, data) =>
  api.post(`/admin/v1/users/${userId}/subscription/grant`, data)
